export const IMAGE_SHADE_LEVELS = ['none', 'soft', 'mid', 'strong'] as const;
export const DEFAULT_IMAGE_SHADE = 'none';

export type ImageShadeLevel = (typeof IMAGE_SHADE_LEVELS)[number];

const IMAGE_SHADE_STOPS: Record<Exclude<ImageShadeLevel, 'none'>, [number, number, number]> = {
  soft: [0.3, 0.2, 0.05],
  mid: [0.5, 0.35, 0.1],
  strong: [0.7, 0.5, 0.15],
};

export function normalizeImageShade(value: unknown): ImageShadeLevel {
  return IMAGE_SHADE_LEVELS.includes(value as ImageShadeLevel)
    ? (value as ImageShadeLevel)
    : DEFAULT_IMAGE_SHADE;
}

export function imageShadeGradient(level: unknown) {
  const normalized = normalizeImageShade(level);
  if (normalized === 'none') return '';
  const stops = IMAGE_SHADE_STOPS[normalized];
  const alpha = (stop: number) => Number(stop).toFixed(2);
  return `linear-gradient(to top, rgba(0, 0, 0, ${alpha(stops[0])}) 0%, rgba(0, 0, 0, ${alpha(stops[1])}) 35%, rgba(0, 0, 0, ${alpha(stops[2])}) 100%)`;
}

/** Prepends the shade layer to a CSS background-image. `none` leaves the image alone. */
export function withImageShade(backgroundImage: string | undefined, level: unknown) {
  if (!backgroundImage) return backgroundImage;
  const gradient = imageShadeGradient(level);
  if (!gradient) return backgroundImage;
  return `${gradient}, ${backgroundImage}`;
}
